import { FC, MouseEvent, useCallback } from 'react';
import { Box, Input } from '@robocorp/components';
import { useTranslation } from 'react-i18next';
import { CopyToClipboard } from '~/components';

type Props = {
  label: string;
  value?: string;
};

export const ApiHelperInput: FC<Props> = ({ label, value }) => {
  const { t } = useTranslation();

  const empty = typeof value !== 'string';

  const onInputClick = useCallback((e: MouseEvent<HTMLInputElement>) => {
    const input = e.currentTarget;

    input.selectionStart = 0;
    input.selectionEnd = input.value.length;
  }, []);

  return (
    <Box display="flex" gap={8} mb={12} width="100%" alignItems="flex-end">
      <Box flex={1}>
        <Input
          onClick={onInputClick}
          disabled={empty}
          label={label}
          placeholder={t('notSet')}
          value={value}
        />
      </Box>
      <CopyToClipboard disabled={empty} plain text={t('copy')} value={value || ''} />
    </Box>
  );
};
